import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Tab } from './models/tab.model';
import { Router, NavigationEnd } from '@angular/router';
import { TabService } from './services/tab.service';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { LocalStorage } from 'ngx-store';

@Component({
  selector: 'app-header-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss']
})
export class TabsComponent implements OnInit, OnDestroy {

  @LocalStorage("tabs_core") navLinks: Tab[];
  private subscription$: Subscription;
  user: any;
  applicableHomepage = '/dashboard/page/vessel';

  constructor(
    private router: Router,
    private tabService: TabService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.user = JSON.parse(localStorage.getItem('user'));

    if (this.user && this.user.applicableHomepage && this.user.applicableHomepage.url){
      this.applicableHomepage = this.user.applicableHomepage.url;
    }

    this.subscription$ = this.tabService.tabs().subscribe((tabs: Tab[]) => {

      this.navLinks =  tabs;

      this.cdr.detectChanges();
    });

    this.router.events.subscribe((event: NavigationEnd) => {
      this.cdr.detectChanges();
    });
  }

  title(link){
    if (link.path.includes('COC')){
        return 'regular-line-coc.page.title';
    } else if (link.path.includes('CRG')){
        return 'regular-line.page.title';
    } else {
        return 'Loading...';
    }
  }

  isCurrent(index): boolean {
    const segmentsCurrent = this.router.url;
    const segments = this.navLinks[index].path;
    if (segments === segmentsCurrent) {
      return true;
    }
    return false;
  }

  ngOnDestroy() {
    if (this.subscription$) {
      this.subscription$.unsubscribe();
    }
  }

  isHome(): boolean {
    const currentUrl = this.router.url;
    if(currentUrl.includes(this.applicableHomepage)) {
      return true;
    } else {
      return false;
    }
  }

  public closeTab(event, index: number) {
    event.stopPropagation();
    const tab = this.navLinks[index];
    this.cdr.detectChanges();

    this.tabService.removeTab(index);

    if (tab.path === this.router.url) {
      const last = this.navLinks[
        index + 1 > this.navLinks.length - 1 ? this.navLinks.length - 1 : index
      ];
      if (!last) {
        window.location.href = this.redirectToHomepage;
        return;
      }
      const path = last.path;
      this.router.navigateByUrl(path);
    }
  }

  clickOnTab(url: string){
    this.navigateByUrl(url);
  }

  public navigateByUrl(url: string) {
    this.router.navigateByUrl(url);
  }

  get redirectToHomepage(){
    let baseRef = environment.server;
    if (!baseRef.endsWith("/")) {
      baseRef += "/";
    }

    let path = '/dashboard/page/vessel';
    let external = "web/#";

    if (this.applicableHomepage && this.applicableHomepage!='/home'){

      path = this.applicableHomepage;

      if (!path.startsWith("/")) {
        path += "/";
      }

    }

    return baseRef + external + path;

  }

}
